import api from "../api";
import { subAdapter } from "../features/organization/adapter";

function adapter(key, data){
  let result = []

  if(data && data.length > 0){
    if(key === 'social'){
      result = data.map(d => {
        const category = d.kategoriSosialMedia
        const name = category.nama ? category.nama[0].toLowerCase() : category
        return {
          name,
          link: d.linkSosialMedia
        }
      })
    }

    if(key === 'milestone'){
      result = data.map(d => {
        return {
          id: d.pkMilestoneId,
          year: d.tahun,
          description_id: d.deskripsi[0],
          description_en: d.deskripsi[1]
        }
      })
    }
  }

  return result
}

function adapterOrganizationSingle(organisasi){
  let result = {}

  if(organisasi){
    const highlight = organisasi.highlight
    const highlightAvailable = highlight && highlight !== null
    const description = organisasi.deskripsi
    const descriptionAvailable = description && description !== null
    const lokasi = organisasi.lokasiOrganisasi

    result = {
      id: organisasi.organisasiId,
      organizationId: organisasi.organisasiId,
      name: organisasi.namaOrganisasi,
      logo: api.base_image+organisasi.imgLogoOrganisasi,
      image: api.base_image+organisasi.imgMainImage,
      highlight_id: highlightAvailable ? highlight[0] : '',
      highlight_en: highlightAvailable ? highlight[1] : '',
      description_id: descriptionAvailable ? description[0] : '',
      description_en: descriptionAvailable ? description[1] : '',
      status: organisasi.statusVerification,
      institution: organisasi.institutionProfile,
      total_member: organisasi.teamMember ? organisasi.teamMember.length : organisasi.totalMember,
      types: organisasi.typeOrganisasi,
      since: organisasi.tahunBerdiri,
      approaches: organisasi.typeApproach,
      location: lokasi && lokasi[0] ? `${lokasi[0].kota}, ${lokasi[0].provinsi}` : '-',
      address: lokasi && lokasi[0] ? `${lokasi[0].jalan}` : '-',
      issues: organisasi.typeIssues,

      email: organisasi.emailOrganisasi,
      phone: organisasi.teleponOrganisasi,

      milestones: adapter('milestone', organisasi.milestoneOrganisasi),
      socialLinks: adapter('social', organisasi.sosialMedia),

      requests: organisasi.requestedByIndividu,
      members: organisasi.teamMember ? organisasi.teamMember.map(m => {
        return {
          joinId: m.pkJoinedOrganizationId,
          id: m.individu ? m.individu.userId : '',
          name: m.individu ? m.individu.namaIndividu : '',
          image: m.individu ? api.base_image+m.individu.imgFotoProfile : '',
          status: 'Joined',
          role: '-',
        }
      }) : [],
      website: organisasi.websiteOrganisasi,
      featured_programs: subAdapter.programs.responseBodyToRender(organisasi.featuredContent?.featuredProgram),
      /**
       * @todo match social media data structure
       */
      link_facebook: '',
      link_instagram: '',
      link_youtube: '',
      link_twitter: '',
      link_linkedin: '',
      link_medium: '',
      link_pinterest: '',
      link_other: '',
    }
  }

  return result
}

export { adapterOrganizationSingle }
